<template>
  <div id="lm-table-custom">

    <div class="row mb-3">

      <div class="app-search d-xl-block col-md-7">
        <div class="input-group">
          <input
            type="text"
            v-model.trim="apiCall.term"
            class="form-control"
            @keyup.delete.exact="inputClean"
            @keyup.ctrl.88="inputClean"
            @keyup.enter.exact="getItems(apiCall)"
            :placeholder="$t('search_placeholder')">
          <span class="mdi mdi-magnify"></span>
          <div class="input-group-append">
            <button class="btn btn-primary" type="button" @click="searchItems">{{$t('search')}}</button>
          </div>
        </div>
      </div>

      <div class="input-group col-md-3 mt-3 mt-sm-0 col-6">
        <div class="input-group-prepend d-none d-lg-block">
          <label class="input-group-text" for="selectOrder"> {{$t('order_by')}} </label>
        </div>
        <select v-model="apiCall.orderBy" class="custom-select" id="selectOrder">
          <option v-for="(el, i) in orderBySetting" :key="i" :value="el">{{ keyReadableForHuman(el) }}</option>
        </select>
      </div>

      <div class="input-group col-md-2 mt-3 mt-sm-0 col-6">
        <div class="input-group-prepend d-none">
          <label class="input-group-text" for="selectOrder"> {{$t('order')}} </label>
        </div>
        <select v-model="apiCall.order" class="custom-select custom-select__all-border-radious" id="selectOrder">
          <option v-for="(el, i) in order" :key="i">{{ el }}</option>
        </select>
      </div>

      <LmDate
        v-model="dateTime.from"
        placeholder="Select Date"
        :label="$t('min_date')"
        :config="lmDateConfigFrom"
        id="dateTimeFrom"
        :layout="['input-group','col-md-6 mt-3']"
        v-if="showFilterTime"
        />
      <LmDate
        v-model="dateTime.upTo"
        placeholder="Select Date"
        :label="$t('max_date')"
        :config="lmDateConfigUpTo"
        id="dateTimeUpTo"
        :layout="['input-group', 'col-md-6 mt-3']"
        v-if="showFilterTime"
        />
    </div> <!-- Row -->

    <div class="table-responsive">
      <div class="table-wrapper">
        <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="top" />
        <table class="table table-striped">
          <thead ref="myThead">
            <tr>
              <th scope="col" v-for="(el, index) in tableHeader" :key="index">
                <div class="th-wrapper">
                  <span>
                    {{ keyReadableForHuman(el) }}
                  </span>
                  <div class="wrapper-icons" v-if="isOrderly(el)">
                    <font-awesome-icon
                      :class="{ active: activeSortTableHeader(el, 'asc')}"
                      @click="orderByIcon(el, 'asc')"
                      icon="sort-up"
                    />
                    <font-awesome-icon
                      :class="{ active: activeSortTableHeader(el, 'desc')}"
                      @click="orderByIcon(el, 'desc')"
                      icon="sort-down"
                    />
                  </div>
                </div>
              </th>
              <th v-if="actions.length">
                <span>{{$t('actions')}}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tr, index) in tableItems" :key="index">
              <td
                v-for="(objContent, key, index) in tr"
                :key="index"
                :style="highlightColummnStyles(objContent, key)"
                >
                <span class="font-13 mb-1 font-weight-normal">{{ objContent }}</span>
              </td>
              <td class="align-middle" v-if="actions.length">
                  <router-link
                    :to="actionsObj.edit.path + tr[actionsObj.edit.registryId]"
                    v-if="actions.some(e => e.name === 'edit')"
                    class="p-1 d-inline-block">
                    <font-awesome-icon
                      icon="edit"
                      size="lg"
                      class="clickable"
                      />
                  </router-link>
                  <div class="p-1 d-inline-block" v-if="actions.some(e => e.name === 'delete')">
                    <font-awesome-icon
                      icon="trash-alt"
                      size="lg"
                      class="clickable"
                      v-b-modal.deleteModal
                      @click="getSelectedRegistry(tr)"
                      />
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="showed-items col-md-2 mt-3 align-self-center">
        <p>{{ apiCall.offset + 1 }} {{$t('to')}} {{ apiCall.offset  + tableItems.length }} {{$t('of')}} {{tableItemsTotal}} </p>
      </div>
      <div class="col-md-7 mt-sm-3">
        <LmPagination
          :allRegistries="tableItemsTotal"
          :maxAmountItemsShowsPerPaginationInTable="apiCall.limit"
          @paginationNumberClick="getTableItems($event)"
          :maxAmountNumbersToShowInPagination="6"
          />
      </div>
      <div class="input-group col-md-3 mt-3 align-self-start" v-if="false">
        <div class="input-group-prepend">
          <label class="input-group-text" for="inputGroupSelect01"> {{$t('per_page')}} </label>
        </div>
        <select v-model.number="itemsPerPage" class="custom-select" id="inputGroupSelect01">
          <option v-for="(el, i) in perPageSetting" :key="i">{{ el }}</option>
        </select>
      </div>
    </div>
    <b-modal
      id="deleteModal"
      ref="deleteModal"
      title="Eliminar registro"
      title-tag="h3"
      :cancel-title="$t('No')"
      :ok-title="$t('Yes')"
      centered
      lazy
      size="90-percent"
      @ok="ok"
      >
      <p>
        {{$t('delete_register_confirmation')}}
      </p>
      <div class="table-responsive">
        <div class="table-wrapper">
          <table class="table table-striped">
            <thead ref="myThead">
              <tr>
                <th scope="col" v-for="(el, index) in tableHeader" :key="index">
                  <div class="th-wrapper">
                    <span>
                      {{ keyReadableForHuman(el) }}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  v-for="(objContent, key, index) in registrySelected"
                  :key="index"
                  :style="highlightColummnStyles(objContent, key)"
                  >
                  <span class="font-13 mb-1 font-weight-normal">{{ objContent }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <LmModalError :message="lmModalError.message"/>
    <LmButton
      type="button"
      :tooltip="{value:$t('can_not_export_csv'), showOnlyOnDisabled: true}"
      @click.native="exportCsv(tableItemsTotal)"
      value="Export Csv"
      lmButtonRootWrapperClass="d-inline-block"
      lmButtonWrapperClass="col"
      :disabled="tableItemsTotal > exportCsvData.limitExportFromClient"
      :isProcessing="exportCsvData.isLoading"
      />
  </div>
</template>

<script>
import LmPagination from '@/components/LmPagination'
import LmButton from '@/components/form/elements/LmButton'
import LmModalError from '@/components/modals/LmModalError'
import LmDate from '@/components/form/elements/LmDate'

import { mapState, mapActions } from 'vuex'

import Papa from 'papaparse'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSortUp, faSortDown, faEdit, faTrashAlt, faPlusSquare } from '@fortawesome/free-solid-svg-icons'
library.add(faSortUp, faSortDown, faEdit, faTrashAlt, faPlusSquare)

export default {
  components: {
    LmPagination,
    LmButton,
    LmModalError,
    LmDate
  },
  data () {
    return {
      dateTime: {
        from: '',
        upTo: ''
      },
      actionsObj: {
        edit: this.actions.find(element => element.name === 'edit')
      },
      lmModalError: {
        message: ''
      },
      registrySelected: {},
      valueSelectPaginationMobile: 1,
      search: '',
      top: 0,
      exportCsvData: {
        limitExportFromClient: this.limitExportFromClient,
        isLoading: false
      },
      apiCall: {
        path: this.apiCallPath,
        offset: 0,
        limit: 10,
        term: null,
        order: this.order[0],
        orderBy: this.orderBySetting[0],
        dateFrom: null,
        dateUpTo: null
      }
    }
  },
  props: {
    itemsPerPage: {
      type: Number,
      default: 10
    },
    perPageSetting: {
      type: Array,
      default: function () {
        return [5, 10, 15, 20]
      }
    },
    limitExportFromClient: Number,
    order: {
      type: Array,
      required: true
    },
    'orderBySetting': {
      type: Array,
      required: true
    },
    'apiCallPath': {
      type: String,
      required: true
    },
    highlight: {
      type: Object,
      default: function () {
        return {
          column: null,
          background: '#fa5c7c',
          fontColor: 'white'
        }
      }
    },
    actions: {
      type: Array,
      default: function () {
        return []
      }
    },
    showFilterTime: {
      type: Boolean,
      default: true
    },
    downloadCsvFileName: {
      type: String,
      default: 'download'
    }
  },
  computed: {
    ...mapState('commons', ['tableItems', 'csvItems', 'tableItemsTotal', 'loading']),
    lmDateConfigFrom: function () {
      return {
        maxDate: this.dateTime.upTo || this.lmDateConfigUpTo.maxDate
      }
    },
    lmDateConfigUpTo: function () {
      return {
        maxDate: 'today'
      }
    },
    tableHeader: function () {
      const tableHeaderValues = this.tableItems.map((el) => {
        return Object.keys(el)
      })
      return tableHeaderValues[0]
    }
  },
  watch: {
    itemsPerPage: function () {
      this.apiCall.limit = this.itemsPerPage
      this.$nextTick()
        .then(() => {
          this.top = this.$refs.myThead.clientHeight
        })
      this.getTableItems()
    },
    'apiCall.order': function () {
      this.getTableItems()
    },
    'apiCall.orderBy': function () {
      this.getTableItems()
    },
    'dateTime.from': function () {
      this.apiCall.dateFrom = this.dateTime.from
      this.getItems(this.apiCall)
    },
    'dateTime.upTo': function () {
      this.apiCall.dateUpTo = this.dateTime.upTo
      this.getItems(this.apiCall)
    }
  },
  methods: {
    ...mapActions('commons', ['getItems', 'getCsvItems']),
    exportCsv (limit) {
      const apiCallCsV = Object.assign({}, this.apiCall)
      apiCallCsV.limit = limit
      this.exportCsvData.isLoading = true
      this.getCsvItems(apiCallCsV)
        .then((r) => {
          const csv = Papa.unparse(this.csvItems)
          const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
          let csvURL = null
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, `${this.downloadCsvFileName}.csv`)
          } else {
            csvURL = window.URL.createObjectURL(csvData)
          }
          const tempLink = document.createElement('a')
          tempLink.href = csvURL
          tempLink.setAttribute('download', `${this.downloadCsvFileName}.csv`)
          tempLink.click()
        })
        .catch((error) => {
          this.lmModalError.message = error.message
          this.$root.$emit('bv::show::modal', 'errorModal')
        })
        .finally(() => {
          this.exportCsvData.isLoading = false
        })
    },
    ok (bvEvt) {
      bvEvt.preventDefault()
      this.$refs.deleteModal.hide()
    },
    getSelectedRegistry (registry) {
      this.registrySelected = registry
    },
    getTableItems (paginationNumberActivated) {
      if (paginationNumberActivated) {
        this.setApiCallOffset(paginationNumberActivated)
      }
      this.$nextTick()
        .then(() => {
          this.top = this.$refs.myThead.clientHeight
        })
      this.getItems(this.apiCall)
    },
    highlightColummnStyles (objContent, key) {
      if (key === this.highlight.column && objContent === true) {
        return { backgroundColor: this.highlight.background, color: this.highlight.fontColor }
      }
    },
    isOrderly (el) {
      return this.orderBySetting.includes(el)
    },
    activeSortTableHeader (el, order) {
      return this.apiCall.orderBy === el && this.apiCall.order === order
    },
    orderByIcon (el, order) {
      this.apiCall.orderBy = el
      this.apiCall.order = order
    },
    keyReadableForHuman (key) {
      let keyText = key.replace(/([A-Z])/g, ' $1').trim().replace(/_/g, ' ')
      return keyText.charAt(0).toUpperCase() + keyText.slice(1)
    },
    inputClean () {
      if (!this.apiCall.term) {
        this.getTableItems()
      }
    },
    searchItems () {
      this.getTableItems()
    },
    setApiCallOffset (paginationNumberActivated) {
      this.apiCall.offset = (paginationNumberActivated - 1) * this.apiCall.limit
    }
  },
  mounted () {
    this.getTableItems()
  }
}
</script>

<style lang="sass" scoped>
  .app-search
    padding: 0 15px
    @media(max-width: $md)
      margin-top: 1.5rem !important
    input
      border: 1px solid #ced4da !important
  select
    option
      &::first-letter
        text-transform: uppercase
        color: red
  .table-responsive
    border: none
    @media(max-width: $xl)
      border: 1px solid #dee2e6
    .table-wrapper
      position: relative
      border: 1px solid #dee2e6
      min-height: 130px
      max-height: 380px
      overflow: auto
      @media(max-width: $xl)
        border: none
    table
      height: 1px
      margin-top: 0 !important
      margin-bottom: 0 !important
      max-width: 100%
      table-layout: fixed
      overflow-wrap: break-word
      @media(max-width: $xl)
        table-layout: auto
      td
        height: 100%
        span
          &.font-13
            font-size: 13px
      thead
        tr
          th
            height: 100%
            position: sticky
            background: white
            top: -1px
            .th-wrapper
              display: flex
              justify-content: space-between
              height: 100%
              span
                align-self: center
              .wrapper-icons
                display: flex
                flex-direction: column
                justify-content: center
                margin-left: 5px
                svg
                  cursor: pointer
                  position: relative
                  opacity: 0.5
                  &.active
                    opacity: 1
</style>
